'use client';

import React from 'react';
import { Chip } from '@heroui/react';
import { EarnData } from '../types';
import { getCampaignTypeColors } from '../constants';

interface SourceCellProps {
  data: EarnData;
}

const SourceCell: React.FC<SourceCellProps> = ({ data }) => {
  const colors = getCampaignTypeColors();
  const typeColor = colors[data.compaign_type] || colors.ref_share;
  const label = data.compaign_type === 'cpl' ? 'CPL' : 'RevShare';

  return (
    <div className="flex items-center gap-2">
      <Chip
        size="sm"
        classNames={{
          base: `${typeColor.bg} h-6 px-2`,
          content: `${typeColor.text} text-xs font-medium p-0`,
        }}
      >
        {label}
      </Chip>
    </div>
  );
};

export default SourceCell;
